(() => {
  const existingBootstrap = window.ChefollaPlatformGuarantees;

  if (existingBootstrap) {
    existingBootstrap.initAll(document);
    return;
  }

  class PlatformGuarantees {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-platform-guarantees-track]');
      this.items = this.track ? Array.from(this.track.querySelectorAll('[data-platform-guarantees-item]')) : [];
      this.dots = Array.from(root.querySelectorAll('[data-platform-guarantees-dot]'));
      this.activeIndex = 0;
      this.animationFrame = null;

      this.handleScroll = () => this.scheduleUpdate();
      this.handleResize = () => this.scheduleUpdate();

      this.init();
    }

    init() {
      if (!this.track || this.items.length < 2 || this.dots.length === 0) return;

      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.updateActiveIndex();
    }

    scheduleUpdate() {
      if (this.animationFrame) return;

      this.animationFrame = window.requestAnimationFrame(() => {
        this.animationFrame = null;
        this.updateActiveIndex();
      });
    }

    updateActiveIndex() {
      if (!this.track || this.items.length === 0) return;

      const trackStyles = window.getComputedStyle(this.track);
      const leadingPadding = Number.parseFloat(trackStyles.paddingLeft) || 0;
      const targetPosition = this.track.scrollLeft + leadingPadding;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      this.items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - targetPosition);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      if (closestIndex === this.activeIndex && this.dots[closestIndex]?.classList.contains('is-active')) return;

      this.activeIndex = closestIndex;
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === closestIndex));
    }

    destroy() {
      window.cancelAnimationFrame(this.animationFrame);
      this.track?.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      delete this.root.platformGuaranteesInstance;
    }
  }

  function collectRoots(container) {
    const roots = [];
    if (container.matches?.('[data-platform-guarantees]')) roots.push(container);
    roots.push(...(container.querySelectorAll?.('[data-platform-guarantees]') || []));
    return roots;
  }

  function initAll(container) {
    collectRoots(container).forEach((root) => {
      if (!root.platformGuaranteesInstance) root.platformGuaranteesInstance = new PlatformGuarantees(root);
    });
  }

  function destroyAll(container) {
    collectRoots(container).forEach((root) => root.platformGuaranteesInstance?.destroy());
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyAll(event.target));

  window.ChefollaPlatformGuarantees = { initAll, destroyAll };
  initAll(document);
})();
